import { createSlice } from "@reduxjs/toolkit";
import { BuyStateProps } from "../interfaces/buy";

const initialState: BuyStateProps = {
    vehicle: {},
    fetchingPostPayment: "unknown",
    errorPayment: "",
    onlinePayment: undefined,
    fetchingPaymentStatus: "unknown",
    paymentStatus: "unknown"
};

const buySlice = createSlice({
    name: "buy",
    initialState,
    reducers: {
        setVehicle: (state, action) => {
            state.vehicle = action.payload;
        },
        postPaymentRequest: (state) => {
            state.fetchingPostPayment = "loading";
        },
        postPaymentSuccess: (state, action) => {
            state.fetchingPostPayment = "success";
            state.onlinePayment = action.payload;
        },
        postPaymentFailure: (state, action) => {
            state.fetchingPostPayment = "failure";
            state.errorPayment = action.payload;
        },
        cleanPostPayment: (state) => {
            state.fetchingPostPayment = initialState.fetchingPostPayment;
            state.errorPayment = initialState.errorPayment;
            state.onlinePayment = initialState.onlinePayment;
            state.vehicle = initialState.vehicle;
            state.fetchingPaymentStatus = initialState.fetchingPaymentStatus;
            state.paymentStatus = initialState.paymentStatus;
        },
        cleanPayment: (state) => {
            state.fetchingPostPayment = initialState.fetchingPostPayment;
            state.errorPayment = initialState.errorPayment;
            state.onlinePayment = initialState.onlinePayment;
            state.fetchingPaymentStatus = initialState.fetchingPaymentStatus;
            state.paymentStatus = initialState.paymentStatus;
        },
        getPaymentStatusRequest: (state) => {
            state.fetchingPaymentStatus = "loading";
        },
        getPaymentStatusSuccess: (state, action) => {
            state.fetchingPaymentStatus = "success";
            state.paymentStatus = action.payload;
        },
        getPaymentStatusFailure: (state) => {
            state.fetchingPaymentStatus = "failure";
        },
        cleanGetPaymentStatus: (state) => {
            state.fetchingPaymentStatus = initialState.fetchingPaymentStatus;
            state.paymentStatus = initialState.paymentStatus;
        }
    },
});

export const { 
    setVehicle,
    postPaymentRequest,
    postPaymentSuccess,
    postPaymentFailure,
    cleanPostPayment,
    getPaymentStatusRequest,
    getPaymentStatusFailure,
    getPaymentStatusSuccess,
    cleanGetPaymentStatus,
    cleanPayment
 } = buySlice.actions;

export default buySlice.reducer;